import type { TPayload } from 'commonTypes/api/scenarios/BaseTypes';

import { withTimeout } from '../withTimeout';

import { KASPERSKY_DAS_LOGIN_START_TIMEOUT_MS } from './constants';
import { ensureDasScriptLoaded } from './ensureDasScriptLoaded';
import { isKfpReady } from './isKfpReady';

let cachedKsid = '';

const getKasperskySessionId = async (): Promise<string> => {
  if (cachedKsid) {
    return cachedKsid;
  }

  try {
    await ensureDasScriptLoaded();

    if (!isKfpReady()) {
      return '';
    }

    const ksid = (await withTimeout(window.kfp!.login_start(), KASPERSKY_DAS_LOGIN_START_TIMEOUT_MS, '')) ?? '';

    if (ksid) {
      cachedKsid = ksid;
    }

    return ksid;
  } catch {
    return '';
  }
};

export const enrichNextPayloadWithKaspersky = async (payload?: TPayload): Promise<TPayload> => {
  const ksid = await getKasperskySessionId();

  return {
    ...(payload || {}),
    ksid,
  };
};
